import { array } from "yup";
import { propertyBuildingFormSchema } from "../building-form/building.schema";
import { checkIsProject, enumKeyFormPropery } from "../helps";

const projectStepSchema = {
  building: array()
    .label("Etapas y unidades")
    .of(propertyBuildingFormSchema)
    .when([enumKeyFormPropery.isProject], {
      is: checkIsProject,
      then: schema => schema.min(1, "Debe agregar al menos un edificio").default([]),
      otherwise: schema => schema.default([])
    }),
  buildingsDeleted: array().default([]),
  unitsDeleted: array().default([])
};
export default projectStepSchema;
